import { Link } from 'react-router-dom';
import { Logo, Wordmark } from '../components/Logo';

export default function HomePage() {
  return (
    <main className="min-h-screen flex flex-col">
      <nav className="px-6 py-4 flex items-center justify-between max-w-6xl mx-auto w-full">
        <Wordmark className="text-ink" />
        <div className="flex items-center gap-4 text-sm">
          <Link to="/login" className="text-ink/70 hover:text-ink">Entrar</Link>
          <Link to="/signup" className="btn-primary text-sm py-2 px-4">Probá gratis</Link>
        </div>
      </nav>

      <section className="flex-1 flex flex-col items-center justify-center px-6 -mt-12">
        <div className="text-center max-w-3xl">
          <p className="text-sm uppercase tracking-[0.2em] text-ash mb-6">Para barberos argentinos</p>
          <h1 className="text-5xl md:text-7xl font-semibold tracking-tighter leading-[1.02]">
            Nunca más te clava
            <br />
            <span className="text-forest">un cliente.</span>
          </h1>
          <p className="mt-8 text-lg md:text-xl text-ink/70 max-w-2xl mx-auto leading-relaxed">
            Turnero online, recordatorios por WhatsApp y cobro de seña con Mercado Pago.
            Tu agenda se llena sola. Tu caja se cierra sola. Vos cortás.
          </p>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <Link to="/signup" className="btn-primary">Probá gratis — 5 minutos</Link>
            <a href="#cómo-funciona" className="text-ink/70 hover:text-ink underline underline-offset-4">
              Cómo funciona
            </a>
          </div>
          <p className="mt-6 text-sm text-ash">
            Sin tarjeta. Sin contratos. Sin descargas para tus clientes.
          </p>
        </div>
      </section>

      <section id="cómo-funciona" className="px-6 py-20 bg-ink text-bone">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-semibold tracking-tighter mb-12">
            Tres cosas. Eso es Tijera.
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <Step n={1} title="Tu cliente reserva en 30 segundos" body="Le mandás un link, elige horario, deja el WhatsApp. Cero apps, cero descargas." />
            <Step n={2} title="WhatsApp le recuerda 24hs antes" body="Te quedás sin clavos. Si igual no viene, le pasás el cobro y listo — la guita es tuya." />
            <Step n={3} title="Tu caja se cierra sola" body="Cobrás con el método que quieras. Las comisiones de tus barberos salen automáticas." />
          </div>
        </div>
      </section>

      <footer className="px-6 py-8 text-center text-xs text-ash">
        <Logo size={20} className="text-ink mx-auto mb-2 opacity-50" />
        © 2026 Tijera · Hecha en Argentina
      </footer>
    </main>
  );
}

function Step({ n, title, body }: { n: number; title: string; body: string }) {
  return (
    <div>
      <div className="num text-gold text-sm mb-3">0{n}</div>
      <h3 className="text-xl font-semibold tracking-tight mb-2">{title}</h3>
      <p className="text-bone/70 leading-relaxed">{body}</p>
    </div>
  );
}
